import { TVARate, TVACategory } from '../types/estimation-items';

export interface TVARuleConfig {
  itemKey: string;
  tvaRate: TVARate;
  tvaCategory: TVACategory;
  reason: string;
}

export const TVA_RATES = {
  REDUCED: 5.5 as TVARate,
  INTERMEDIATE: 10 as TVARate,
  NORMAL: 20 as TVARate,
} as const;

export const TVA_CATEGORY_DESCRIPTIONS = {
  energy_improvement: 'Amélioration énergétique - TVA 5,5%',
  renovation: 'Rénovation standard - TVA 10%',
  new_construction: 'Construction neuve - TVA 20%',
} as const;

export const TVA_RULES: Record<string, TVARuleConfig> = {
  'mursexterieurs_ite_polystyrene': {
    itemKey: 'mursexterieurs_ite_polystyrene',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique extérieure éligible',
  },
  'mursexterieurs_ite_polystyrene_r4': {
    itemKey: 'mursexterieurs_ite_polystyrene_r4',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique extérieure éligible',
  },
  'mursexterieurs_ite_laineroche': {
    itemKey: 'mursexterieurs_ite_laineroche',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique extérieure éligible',
  },
  'mursexterieurs_ite_fibreboisbardage': {
    itemKey: 'mursexterieurs_ite_fibreboisbardage',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique extérieure éligible',
  },
  'mursexterieurs_iti_lainedeverre': {
    itemKey: 'mursexterieurs_iti_lainedeverre',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique intérieure éligible',
  },
  'mursexterieurs_iti_lainedeveerre_hydro': {
    itemKey: 'mursexterieurs_iti_lainedeveerre_hydro',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique intérieure éligible',
  },
  'mursexterieurs_iti_fibredebois': {
    itemKey: 'mursexterieurs_iti_fibredebois',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation thermique intérieure éligible',
  },
  'combles_soufflage_lainedeverre': {
    itemKey: 'combles_soufflage_lainedeverre',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation combles perdus éligible',
  },
  'combles_soufflage_ouate': {
    itemKey: 'combles_soufflage_ouate',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation combles perdus éligible',
  },
  'combles_rouleaux_lainedeverre': {
    itemKey: 'combles_rouleaux_lainedeverre',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation combles perdus éligible',
  },
  'combles_soustoiture_lainedeverre': {
    itemKey: 'combles_soustoiture_lainedeverre',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation sous toiture éligible',
  },
  'combles_soustoiture_fibrebois': {
    itemKey: 'combles_soustoiture_fibrebois',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation sous toiture éligible',
  },
  'combles_soustoiture_sarking': {
    itemKey: 'combles_soustoiture_sarking',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation toiture par sarking éligible',
  },
  'planchersbas_terreplein_polyurethane': {
    itemKey: 'planchersbas_terreplein_polyurethane',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation plancher bas éligible',
  },
  'planchersbas_terreplein_polystyrene': {
    itemKey: 'planchersbas_terreplein_polystyrene',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation plancher bas éligible',
  },
  'planchersbas_videsanitaire_projection': {
    itemKey: 'planchersbas_videsanitaire_projection',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation plancher bas éligible',
  },
  'planchersbas_videsanitaire_panneaux': {
    itemKey: 'planchersbas_videsanitaire_panneaux',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Isolation plancher bas éligible',
  },
  'chauffage_chaudieregaz_murale': {
    itemKey: 'chauffage_chaudieregaz_murale',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Chaudière condensation éligible',
  },
  'chauffage_chaudieregaz_sol': {
    itemKey: 'chauffage_chaudieregaz_sol',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Chaudière condensation éligible',
  },
  'chauffage_pacaireau': {
    itemKey: 'chauffage_pacaireau',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'PAC air/eau éligible',
  },
  'chauffage_paceaueau': {
    itemKey: 'chauffage_paceaueau',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'PAC géothermique éligible',
  },
  'plomberie_chauffeeauthermo': {
    itemKey: 'plomberie_chauffeeauthermo',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Chauffe-eau thermodynamique éligible',
  },
  'energiesrenouvelables_panneauxsolaires': {
    itemKey: 'energiesrenouvelables_panneauxsolaires',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Panneaux solaires photovoltaïques en autoconsommation éligibles',
  },
  'energiesrenouvelables_panneauxsolaires_6kwc': {
    itemKey: 'energiesrenouvelables_panneauxsolaires_6kwc',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Panneaux solaires photovoltaïques en autoconsommation éligibles',
  },
  'energiesrenouvelables_chauffeeau_solaire': {
    itemKey: 'energiesrenouvelables_chauffeeau_solaire',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'Chauffe-eau solaire thermique éligible',
  },
  'ventilation_vmcdouble': {
    itemKey: 'ventilation_vmcdouble',
    tvaRate: TVA_RATES.REDUCED,
    tvaCategory: 'energy_improvement',
    reason: 'VMC double flux avec récupération chaleur éligible',
  },
  'piscine_enterree': {
    itemKey: 'piscine_enterree',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Piscine enterrée',
  },
  'piscine_horssol': {
    itemKey: 'piscine_horssol',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Piscine hors-sol',
  },
  'abris_carport_bois': {
    itemKey: 'abris_carport_bois',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Carport bois',
  },
  'abris_carport_metal': {
    itemKey: 'abris_carport_metal',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Carport aluminium',
  },
  'abris_carport_double': {
    itemKey: 'abris_carport_double',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Carport double',
  },
  'abris_jardin_bois': {
    itemKey: 'abris_jardin_bois',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Abri de jardin bois',
  },
  'abris_jardin_metal': {
    itemKey: 'abris_jardin_metal',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Abri de jardin métal',
  },
  'abris_jardin_resine': {
    itemKey: 'abris_jardin_resine',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Abri de jardin résine',
  },
  'abris_serre_jardin': {
    itemKey: 'abris_serre_jardin',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Serre de jardin',
  },
  'toituresexterieures_pergola': {
    itemKey: 'toituresexterieures_pergola',
    tvaRate: TVA_RATES.NORMAL,
    tvaCategory: 'new_construction',
    reason: 'Construction neuve - Pergola bioclimatique',
  },
};

export function determineTVARate(itemKey: string, buildingAge?: number): TVARate {
  const rule = TVA_RULES[itemKey];

  if (rule) {
    if (rule.tvaCategory === 'new_construction') {
      return TVA_RATES.NORMAL;
    }
    return rule.tvaRate;
  }

  if (buildingAge !== undefined && buildingAge < 2) {
    return TVA_RATES.NORMAL;
  }

  return TVA_RATES.INTERMEDIATE;
}

export function getTVACategory(itemKey: string): TVACategory {
  const rule = TVA_RULES[itemKey];
  return rule ? rule.tvaCategory : 'renovation';
}

export function getTVAReason(itemKey: string): string | undefined {
  return TVA_RULES[itemKey]?.reason;
}

export function getBuildingAgeLabel(age?: number): string {
  if (age === undefined) return 'Non renseigné';
  if (age < 2) return 'Moins de 2 ans';
  return 'Plus de 2 ans';
}

export function getTVAInfoMessage(buildingAge?: number): string {
  if (buildingAge === undefined || buildingAge < 2) {
    return 'Pour un logement neuf (moins de 2 ans), la TVA à 20% s\'applique à tous les travaux.';
  }
  return 'Pour un logement de plus de 2 ans, les taux réduits de TVA (5,5% et 10%) s\'appliquent selon la nature des travaux d\'amélioration énergétique et de rénovation.';
}
